import React, { CSSProperties, ReactNode, useEffect, useState } from 'react';

type BannerLayoutProps = {
  children?: ReactNode;
};

const DESKTOP_PADDING = { top: 80, bottom: 120 };
const MOBILE_PADDING = { top: 60, bottom: 100 };
const DESKTOP_MIN_HEIGHT = 320;
const MOBILE_MIN_HEIGHT = 240;
const MAX_HEIGHT = 480;
const MOBILE_BREAKPOINT = 768;

const useIsMobile = (): boolean => {
  const initial = typeof window !== 'undefined'
    ? window.innerWidth < MOBILE_BREAKPOINT
    : false;
  const [isMobile, setIsMobile] = useState(initial);

  useEffect(() => {
    const onResize = () => setIsMobile(window.innerWidth < MOBILE_BREAKPOINT);
    window.addEventListener('resize', onResize);
    return () => window.removeEventListener('resize', onResize);
  }, []);

  return isMobile;
};

const BannerLayout = ({ children }: BannerLayoutProps) => {
  const isMobile = useIsMobile();
  const padding = isMobile ? MOBILE_PADDING : DESKTOP_PADDING;
  const minHeight = isMobile ? MOBILE_MIN_HEIGHT : DESKTOP_MIN_HEIGHT;

  const containerStyle: CSSProperties = {
    position: 'relative',
    width: '100%',
    minHeight: `${minHeight}px`,
    maxHeight: `${MAX_HEIGHT}px`,
    paddingTop: `${padding.top}px`,
    paddingBottom: `${padding.bottom}px`,
    paddingLeft: '16px',
    paddingRight: '16px',
    overflow: 'hidden',
    background: 'linear-gradient(180deg, #F8F9F9 0%, #FFFFFF 100%)',
    boxSizing: 'border-box',
  };

  return (
    <div className="aicrowd-banner-layout" style={containerStyle}>
      {children}
    </div>
  );
};

export default BannerLayout;
